import React, { useRef } from 'react';
import { getSafetyFormCards } from '../config/safetyForms';
import { SafetyFormContent } from '../pages/Dashboard';
import { FormSubmitProvider } from '../context/FormSubmitContext';
import { FormSubmitFeedback, SubmitDetailsButton } from './SubmitDetailsButton';
import { FormActionButtons } from './FormActionButtons';
import { SafetyFormHeader } from './FormSiteTimestampControls';
import { ScrollableRightPane } from './ScrollEdgeButtons';
import { getStoredUser } from '../utils/auth';
import { apiUrl } from '../config/api';
import '../styles/userPrintForms.css';

export function SafetyFormPanel({ formIndex, projectName, onBack }) {
  const formRef = useRef(null);
  const user = getStoredUser();
  const companyLogoUrl = user?.company_logo_url ? apiUrl(user.company_logo_url) : null;
  const companyName = user?.company_name || projectName || '';
  const cards = getSafetyFormCards(projectName);
  const card = cards.find((c) => c.index === formIndex) || cards[formIndex];

  if (!card) {
    return (
      <div>
        <button
          type="button"
          onClick={onBack}
          className="text-sm text-gray-400 hover:text-white mb-4"
        >
          ← Back to dashboard
        </button>
        <p className="text-gray-500 text-sm">Form not found.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col flex-1 min-h-0 w-full">
      <FormSubmitProvider
        formRef={formRef}
        formIndex={formIndex}
        formTitle={card.title}
        userEmail={user?.email}
        companyLogoUrl={companyLogoUrl}
      >
        <div className="flex items-center justify-between gap-4 mb-2 shrink-0">
          <button
            type="button"
            onClick={onBack}
            className="text-sm text-gray-400 hover:text-white flex items-center gap-1"
          >
            ← Back to dashboard
          </button>
          <FormActionButtons />
        </div>

        <div className="flex flex-col flex-1 min-h-0 rounded-lg border border-gray-300 bg-white shadow-sm overflow-hidden">
          <SafetyFormHeader
            title={card.title}
            companyLogoUrl={companyLogoUrl}
            companyName={companyName}
          />
          <ScrollableRightPane
            className="flex-1"
            scrollClassName="px-6 md:px-8 py-4"
            tone="light"
          >
            <div ref={formRef} className="user-print-form">
              <SafetyFormContent formIndex={formIndex} projectName={projectName} />
            </div>
          </ScrollableRightPane>
          <div className="shrink-0 border-t border-gray-300 bg-white px-6 md:px-8 py-2">
            <SubmitDetailsButton />
          </div>
          <FormSubmitFeedback />
        </div>
      </FormSubmitProvider>
    </div>
  );
}
